<script setup lang="ts">
import { cn, formatDateTime, getParam } from '@/lib/utils';
import AppointmentStatus from '@/components/profile/AppointmentStatus.vue';
import { RouterLink } from 'vue-router';
import { useRoute } from 'vue-router';

const route = useRoute();

const props = defineProps({
    appointment: {
        type: Object,
        required: true
    },
    class: {
        type: String,
        default: ''
    }
});
</script>

<template>
    <RouterLink 
        :to="{ 
            name: 'manage_appointment', 
            query: { appID: props.appointment.appID }, 
            params: { domain: getParam(route) } 
        }"
        class="block"
    >
        <div :class="cn(`border border-gray-200 rounded-xl p-3 w-full flex justify-between items-baseline gap-2.5 bg-white shadow relative hover:shadow-md hover:border-gray-300 transition-all cursor-pointer`, props.class)">
            <div class="flex flex-col gap-2">
                <div v-if="props.appointment.pharmacyName" class="font-medium text-sm text-gray-500 leading-relaxed">{{ props.appointment.pharmacyName }}</div>
                <div class="text-gray-900 font-semibold">{{ formatDateTime(props.appointment.appointmentDateTime) }}</div>
                <div class="flex items-center gap-2.5">
                    <img :src="props.appointment.doctorImage || '/default.webp'" :alt="appointment.doctorName" class="size-6 rounded-full border-gray-300 border">
                    <div class="text-gray-900 font-medium text-sm">{{ props.appointment.doctorName }}</div>
                </div>
            </div>
            <AppointmentStatus :status="props.appointment.appointmentStatus" />
        </div>
    </RouterLink>
</template>
